const COPY_EXTERNAL_EVENT_ID_PARAM = 'copyExternalEventId';
const EXTERNAL_COMPETITION_PARAM = 'competition';
const CREATE_EVENT_PATH = '/events/create';
const QUERY_PREFIX = '?';
const EMPTY_VALUE = '';

export const readExternalEventCopySearch = (search) => {
  const params = new URLSearchParams(search || EMPTY_VALUE);
  return {
    externalEventId: normalizeParam(params.get(COPY_EXTERNAL_EVENT_ID_PARAM)),
    competition: normalizeParam(params.get(EXTERNAL_COMPETITION_PARAM)),
  };
};

export const buildCreateEventCopyPathForExternalEvent = (externalEventId, competition) => {
  const params = new URLSearchParams();
  appendParam(params, COPY_EXTERNAL_EVENT_ID_PARAM, externalEventId);
  appendParam(params, EXTERNAL_COMPETITION_PARAM, competition);
  const query = params.toString();
  return query ? `${CREATE_EVENT_PATH}${QUERY_PREFIX}${query}` : CREATE_EVENT_PATH;
};

// ===================================================================================================================
// = Implementation
// ===================================================================================================================

const appendParam = (params, name, value) => {
  const normalized = normalizeParam(value);
  if (normalized) params.set(name, normalized);
};

const normalizeParam = (value) => String(value || EMPTY_VALUE).trim();
